<template>
  <div>
    <div class="container watermark-container">
      <van-nav-bar title="OA审批" />

      <!-- 偏好模板快捷入口 -->
      <div
        v-if="preferredTemplates.length || showAddBtn"
        class="preferred-section"
      >
        <div class="preferred-title">
          我的常用模板
          <van-button
            size="small"
            type="primary"
            plain
            icon="plus"
            @click="showPicker = true"
          >
            添加
          </van-button>
        </div>

        <van-row class="preferred-row" gutter="8">
          <van-col
            v-for="template in preferredTemplates"
            :key="template.id"
            span="6"
          >
            <div class="item">
              <img :src="template.iconUrl" @click="apply(template.id)" />
              <span @click="apply(template.id)">{{ template.name }}</span>
              <div class="delete" @click="removeFavorite(template.id)">✕</div>
            </div>
          </van-col>
        </van-row>
      </div>

      <!-- 弹窗选择模板 -->
      <van-popup v-model="showPicker" position="bottom" round closeable>
        <div class="popup-container">
          <div class="popup-title">请选择要添加的模板</div>
          <van-row gutter="8">
            <van-col
              v-for="tpl in allTemplatesFlat"
              :key="tpl.id"
              span="6"
              @click="addFavorite(tpl)"
            >
              <div class="item">
                <img :src="tpl.iconUrl" />
                <span>{{ tpl.name }}</span>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-popup>

      <van-collapse v-model="activeNames">
        <van-collapse-item
          v-for="(item, key) in list"
          :key="key"
          :title="item.name"
          :name="item.key"
        >
          <van-row>
            <van-col
              v-for="template in item.processTemplateList"
              :key="template.id"
              span="6"
            >
              <div class="item" @click="apply(template.id)">
                <img :src="template.iconUrl" />
                <span>{{ template.name }}</span>
              </div>
            </van-col>
          </van-row>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import api from '@/api/process'
import tempApi from '@/api/processTemplatePreference'
import addWatermark from '@/utils/watermark'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'process',

  data() {
    return {
      list: [],
      activeNames: [0, 1, 2, 3, 4],
      preferredTemplates: [],
      favoriteIds: [],
      showPicker: false, // 控制弹框
      showAddBtn: true, // 偏好模板
    }
  },

  created() {
    this.fetchData()
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo, // 从 Vuex 中获取 userInfo
    }),
    allTemplatesFlat() {
      return this.list.reduce((acc, cur) => {
        return acc.concat(cur.processTemplateList || [])
      }, [])
    },
  },
  mounted() {
    // 如果 userInfo 没有值，则调用 Vuex action 获取用户信息
    if (!this.userInfo) {
      this.loadUserInfoAndAddWatermark()
    } else {
      // 如果已有 userInfo，直接添加水印
      this.addWatermark()
    }
  },
  methods: {
    // 获取用户信息缓存
    ...mapActions({
      loadUserInfo: 'fetchUserInfo', // 映射 fetchUserInfo 到组件的方法
    }),
    // 异步方法：先加载用户信息，再添加水印
    async loadUserInfoAndAddWatermark() {
      try {
        await this.loadUserInfo() // 等待 Vuex action 完成
        this.addWatermark() // 用户信息加载完成后添加水印
      } catch (error) {
        // console.error('加载用户信息失败:', error)
      }
    },
    addWatermark() {
      // console.log('打印水印数据:' + this.userInfo.name)
      // 调用水印功能
      addWatermark({
        containerSelector: '.watermark-container', // 添加水印的目标容器
        text: '通用锁具 ' + this.userInfo.name, // 自定义水印文本
        font: '16px Arial',
        color: 'rgba(0, 0, 0, 0.15)',
        width: 200,
        height: 150,
        angle: -30,
      })
    },
    fetchData() {
      api.findProcessType().then((response) => {
        console.log(response.data)
        this.list = response.data
        //全部展开
        this.activeNames = []
        this.list.forEach((item, index) => {
          this.activeNames.push(index)
        })
      })
      this.selectPreferenceTemplate()
    },

    apply(id) {
      this.$router.push({ path: '/apply/' + id })
    },
    // 添加偏好模板
    addFavorite(template) {
      if (!this.favoriteIds.includes(template.id)) {
        // 构建 VO 对象
        const vo = {
          processTemplateId: template.id, // 当前选中的模板 ID
        }
        tempApi.save(vo).then((response) => {
          console.log(response.data)
          this.$toast('添加成功')
          this.selectPreferenceTemplate()
        })
      } else {
        this.$toast('已在常用模板中')
      }
    },
    // 删除 偏好模板
    removeFavorite(id) {
      console.log('删除的id:' + id)
      tempApi
        .deletePreferenceTemplatetemplateId(id)
        .then((response) => {
          this.selectPreferenceTemplate()
          this.$toast('删除成功')
        })
        .catch((error) => {
          console.error('删除偏好模板出错:', error)
          this.$toast('删除失败，请稍后再试')
        })
    },
    // 查询偏好模板
    selectPreferenceTemplate() {
      tempApi.selectPreferenceTemplate().then((response) => {
        // 偏好模板
        this.preferredTemplates = response.data
        // 偏好id列表
        this.favoriteIds = this.preferredTemplates.map((t) => t.id)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 50px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }
    span {
      font-size: 12px;
      padding: 8px 4px;
      text-align: center;
    }
  }
}

.preferred-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  margin: 10px 0;
}
.item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }
  span {
    font-size: 12px;
    padding-top: 4px;
    text-align: center;
  }
  .delete {
    position: absolute;
    top: 2px;
    right: 4px;
    color: #f44;
    font-size: 14px;
    cursor: pointer;
  }
}
.popup-container {
  padding: 10px;
  .popup-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
